<ng-container [formGroup]="formGroup">
  <dsd-container
    margin="none"
    padding="md"
    border-radius="sm"
    class="info-adresse dsd-br-md dsd-mb-md"
    background-color="dsd-color-background-decorative-graphite-100">
    <p class="dsd-fw-bold dsd-t-6 dsd-mb-sm">{{ libelleAdresseActuelle | translate }}</p>
    <p class="dsd-fw-bold dsd-m-0 dsd-color-font-secondary line-adresse" [innerHTML]="adresseCourante | adresse"></p>
  </dsd-container>
  <dsd-radio-group required="true" class="dsd-mb-md" identifier="utiliserMemeAdresse" name="utiliserMemeAdresse">
    <span slot="legend">{{ 'caad.modifier-fiserv.coordonnees.question' | translate }}</span>
    <span slot="error">{{ 'caad.modifier-fiserv.coordonnees.erreurRadio' | translate }}</span>
    <dsd-radio
      name="utiliserMemeAdresse-oui"
      value="oui"
      [checked]="formGroup.get('utiliserMemeAdresse')?.value === true"
      (dsdRadioChange)="utiliserMemeAdresse(true)">
      {{ 'caad.modifier.coordonnees.oui' | translate }}
    </dsd-radio>
    <dsd-radio
      name="utiliserMemeAdresse-non"
      value="non"
      [checked]="formGroup.get('utiliserMemeAdresse')?.value === false || adressePostDatee"
      (dsdRadioChange)="utiliserMemeAdresse(false)">
      {{ 'caad.modifier.coordonnees.non' | translate }}
    </dsd-radio>
  </dsd-radio-group>
  <div class="dsd-mb-md" *ngIf="formGroup.get('utiliserMemeAdresse')?.value === false">
    <dsd-address
      required="true"
      [international]="isBancaire"
      (dsdAddressReady)="onAddressReady($event)"
      (dsdAddressUpdated)="onAddressSelected($event)"
      [config]="configAdresse">
      <span slot="legend">{{ libelleNouvelleAdresse | translate }}</span>
      <span slot="description" *ngIf="!isBancaire">{{ 'caad.modifier-fiserv.coordonnees.directive' | translate }}</span>
      <dsd-datepicker
        *ngIf="isBancaire"
        required
        [min]="dateMin"
        [max]="dateMax"
        [value]="formGroup.get('dateChangement')?.value || ''"
        (dsdDatepickerChange)="onDateChangement($event)">
        <span slot="label">{{ 'caad.modifier-coordonnees.adresse.dateChangement' | translate }}</span>
        <span slot="hint">{{ 'caad.modifier-coordonnees.adresse.guidage' | translate }}</span>
      </dsd-datepicker>
      <dsd-v-spacer size="sm"></dsd-v-spacer>
    </dsd-address>
  </div>
</ng-container>
